import type { Theme } from '@/themes/types'

/**
 * Converts a hex color to rgba format with specified alpha value
 * @param hex - Hex color string (e.g., "#ff0000")
 * @param alpha - Alpha value between 0 and 1
 * @returns RGBA color string (e.g., "rgba(255, 0, 0, 0.5)")
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * Gets a color from the theme with optional fallback
 * @param theme - Theme object
 * @param colorKey - Key of the color in theme.colors
 * @param fallback - Optional fallback color if key doesn't exist
 * @returns The color value
 */
export const getThemeColor = (theme: Theme, colorKey: keyof Theme['colors'], fallback?: string): string => {
  return theme.colors[colorKey] ?? fallback ?? 'inherit'
}
